import { Draggable } from "react-beautiful-dnd";
import { useDispatch } from "react-redux";
import styled from "styled-components";
import { IsoToDateWithoutTime } from "../../../CommonFunction/IsoDateTime";
import { useModalContext } from "../../Components/Reactportal/ModalContext";
import "./LRCard.scss";
import { getTableKey } from "./OperationsManagement";

export function getTableKeyForEdit(name) {
  let tableKey = "";
  switch (name) {
    case "Assingn_Pickup":
      tableKey = "Pickup_Memo";
      break;
    case "Pickup_Assigned":
      tableKey = "Pickup_Memo";
      break;
    case "Pickup_Done":
      tableKey = "CN_Pickup_Updation";
      break;
    case "Reached_at_CC":
      tableKey = "Inward_Connection";
      break;
    case "Connection_Booked":
      tableKey = "Connection_Memo";
      break;
    case "Connection_Successfull":
      tableKey = "Connection_Memo_Updation";
      break;
    case "Received_At_Destination":
      tableKey = "Connection_Memo_Receive";
      break;
    case "Delivery_Assigned":
      tableKey = "Delivery_Memo";
      break;
    case "Delivery_Confirmation":
      tableKey = "LR_Delivery";
      break;
    default:
      tableKey = "";
  }
  return tableKey;
}

let multiTickCheckboxShow = [
  "Assingn_Pickup",
  "Pickup_Assigned",
  "Pickup_Done",
  "Reached_at_CC",
  "Received_At_Destination",
  "Delivery_Assigned",
];

const LRCard = ({ LRData, index, columnHeader, selectMultiIds, MultiDragableIds, disableLRArr }) => {
  // console.log(LRData, "columnHeader");
  const dispatch = useDispatch();
  const { pushModal, clearModalStack, setCurrentTitle } = useModalContext();
  const idMap = {
    Assingn_Pickup: LRData?._id,
    Pickup_Assigned: LRData?.Pickup_Memo_Data?._id,
    Pickup_Done: LRData?.pickup_Updation_Data?._id,
    Reached_at_CC: LRData?.Inward_Data?._id,
    Connection_Booked: LRData?.Connection_Memo_Data?.[0]?._id,
    Delivery_Assigned: LRData?.Delivery_Memo_Data?._id,
  };

  let ParentPortalCloseFunction = () => {
    clearModalStack();
    setCurrentTitle("Consignment_Note");
    pushModal("Consignment_Note");
    dispatch({ type: "CLEAR_COMPONENT_PROP" });
  };

  let CtrlDoubleClickFun = () => {
    if (!LRData?._id) {
      return;
    }
    // let tablekey = getTableKey(columnHeader);
    dispatch({ type: "CLEAR_ALL_COMPONENT_PROP" });
    clearModalStack();
    setCurrentTitle("Consignment_Note");
    pushModal("Consignment_Note");
    dispatch({
      type: "SET_COMPONENT_PROP",
      payload: {
        Table_Key: "Consignment_Note",
        props: {
          show: true,
          ParentPortalCloseFunction,
          TypeOfPortal: "Edit",
          submitType: "",
          openByCard: true,
          openByCardId: LRData?._id ?? null,
        },
      },
    });
  };

  let openEditfun = () => {
    if (columnHeader == "Connection_Successfull" || columnHeader == "Received_At_Destination") {
      return;
    } else if (!idMap[columnHeader]) {
      return;
    }
    let tablekey = getTableKey(columnHeader);

    dispatch({ type: "CLEAR_ALL_COMPONENT_PROP" });
    clearModalStack();
    setCurrentTitle(tablekey);
    pushModal(tablekey);
    // console.log(LrDetailObj, tablekey, "LrDetailObj");
    dispatch({
      type: "SET_COMPONENT_PROP",
      payload: {
        Table_Key: tablekey,
        props: {
          show: true,
          ParentPortalCloseFunction,
          TypeOfPortal: "Edit",
          submitType: "",
          openByCard: true,
          openByCardId: idMap[columnHeader] ?? null,
        },
      },
    });
  };

  let handleClickOnCard = (event) => {
    if (event.ctrlKey) {
      CtrlDoubleClickFun();
    } else {
      openEditfun();
    }
  };

  return (
    <>
      <Draggable draggableId={LRData?._id} index={index}>
        {(provided, snapshot) => (
          <StyledTask
            onDoubleClick={(e) => {
              handleClickOnCard(e);
            }}
            ref={provided.innerRef}
            {...provided.draggableProps}
            {...provided.dragHandleProps}
            isDragging={snapshot.isDragging}
          >
            <div className="maincard">
              <div className="consignorCard">
                <div className="consignorNameServiceDate">
                  <div className="consignorNameMaindiv">
                    <div className="blueBox"></div>
                    <div className="consignorName">
                      {LRData?.Consignor}, <span className="city">{LRData?.From_City}</span>{" "}
                    </div>
                  </div>
                  <div className="consignorNameMaindiv">
                    <div className="whiteBox"></div>
                    {LRData?.Consignor_Person_Data?.Name ? (
                      <div className="contact">
                        {LRData?.Consignor_Person_Data?.Name}{" "}
                        {LRData?.Consignor_Person_Data?.Contact && `(${LRData?.Consignor_Person_Data?.Contact})`}
                      </div>
                    ) : (
                      <div className="contact"></div>
                    )}
                  </div>
                  <div className="consignorNameMaindiv">
                    <div className="borderBlue"></div>
                    <div className="consignorName">
                      {LRData?.Consignee}, <span className="city">{LRData?.To_City}</span>
                    </div>
                  </div>
                  <div className="consignorNameMaindiv">
                    <div className="whiteBox"></div>
                    {LRData?.Consignee_Person_Data?.Name ? (
                      <div className="contact">
                        {LRData?.Consignee_Person_Data?.Name}{" "}
                        {LRData?.Consignee_Person_Data?.Contact && `(${LRData?.Consignee_Person_Data?.Contact})`}
                      </div>
                    ) : (
                      <div className="contact"></div>
                    )}
                  </div>
                </div>
                <div className="otherDetails">
                  <div className="serviceTypeMaindiv">
                    <div
                      className="serviceType"
                      style={{ backgroundColor: LRData?.Service_Type_Data?.Mode == "Train" ? "#2ca01c" : "#2363f2" }}
                    >
                      {LRData?.Service_Type_Data?.Service_Type_Name}
                    </div>
                    {multiTickCheckboxShow.includes(columnHeader) && (
                      <input
                        type="checkbox"
                        name=""
                        id=""
                        checked={MultiDragableIds.includes(LRData?._id)}
                        disabled={disableLRArr?.includes(LRData?._id)}
                        onChange={(e) => selectMultiIds(LRData?._id, columnHeader)}
                      />
                    )}
                  </div>
                  <div className="dateortime">{IsoToDateWithoutTime(LRData?.Date)}</div>
                  <div className="dateortime">#{LRData?.Unique_Id}</div>
                  <div className="dateortime">{LRData?.LR_No}</div>
                  <div className="dateortime">{`${LRData?.Total_Number_Of_Boxes} Pcs - ${LRData?.Total_Weight} Kgs`}</div>
                </div>
              </div>
              {/* //////////////////////////////////////// */}
              <div className="customerNoteMaindiv">
                {LRData?.Customer_Note && <div className="customerNote"> {LRData?.Customer_Note}</div>}
                <div className="vehicleDriver">
                  {/* {Driver} */}
                  {LRData?.Pickup_Memo_Data?.Driver_Name_Data?.Name && (
                    <div className="vehicleD">
                      {`${
                        LRData?.Pickup_Memo_Data?.Driver_Name_Data?.Name
                          ? LRData?.Pickup_Memo_Data?.Driver_Name_Data?.Name
                          : ""
                      } (${
                        LRData?.Pickup_Memo_Data?.Driver_Name_Data?.Mobile_Number
                          ? LRData?.Pickup_Memo_Data?.Driver_Name_Data?.Mobile_Number
                          : ""
                      })`}
                    </div>
                  )}
                  {LRData?.pickup_Updation_Data?.Driver_Name_Data?.Name && (
                    <div className="vehicleD">
                      {`${LRData?.pickup_Updation_Data?.Driver_Name_Data?.Name} (${LRData?.pickup_Updation_Data?.Driver_Name_Data?.Mobile_Number})`}
                    </div>
                  )}
                  {LRData?.Delivery_Memo_Data?.Driver_ID_Data?.Name && (
                    <div className="vehicleD">
                      <span>{`${LRData?.Delivery_Memo_Data?.Driver_ID_Data?.Name} (${LRData?.Delivery_Memo_Data?.Driver_ID_Data?.Mobile_Number})`}</span>
                    </div>
                  )}
                  {/* {LRData?.Inward_Data?.Driver_Name?.Name && (
                    <div className="vehicleD">
                      <span>{`${LRData?.Inward_Data?.Driver_Name?.Name} (${LRData?.Inward_Data?.Driver_Name?.Mobile_Number})`}</span>
                    </div>
                  )} */}
                  {/* {Driver} */}

                  {/* {Vehicle} */}
                  {LRData?.Delivery_Memo_Data?.Vehicle_No_Data && (
                    <div className="vehicleD">
                      {LRData?.Delivery_Memo_Data?.Vehicle_No_Data?.RC_Number ||
                        LRData?.Delivery_Memo_Data?.Vehicle_No_Data?.Vehicle_No}
                    </div>
                  )}
                  {LRData?.Pickup_Memo_Data?.Vehicle_Data && (
                    <div className="vehicleD">
                      {LRData?.Pickup_Memo_Data?.Vehicle_Data?.RC_Number ||
                        LRData?.Pickup_Memo_Data?.Vehicle_Data?.Vehicle_No}
                    </div>
                  )}
                  {LRData?.Connection_Memo_Data?.[0]?.Vehicle_Data && (
                    <div className="vehicleD">
                      {LRData?.Connection_Memo_Data[0]?.Vehicle_Data?.RC_Number ||
                        LRData?.Connection_Memo_Data[0]?.Vehicle_Data?.Vehicle_No}
                    </div>
                  )}
                  {LRData?.pickup_Updation_Data?.Vehicle_No_Data && (
                    <div className="vehicleD">
                      {LRData?.pickup_Updation_Data?.Vehicle_No_Data?.RC_Number ||
                        LRData?.pickup_Updation_Data?.Vehicle_No_Data?.Vehicle_No}
                    </div>
                  )}
                  {LRData?.Connection_Updation_Data?.[0]?.Vehicle_No_Data && (
                    <div className="vehicleD">
                      {LRData?.Connection_Updation_Data[0]?.Vehicle_No_Data?.RC_Number ||
                        LRData?.Connection_Updation_Data[0]?.Vehicle_No_Data?.Vehicle_No}
                    </div>
                  )}
                  {LRData?.Inward_Data?.Vehicle_No && (
                    <div className="vehicleD">
                      {LRData?.Inward_Data?.Vehicle_No?.RC_Number || LRData?.Inward_Data?.Vehicle_No?.Vehicle_No}
                    </div>
                  )}
                  {/* {Vehicle} */}

                  {/* {cc} */}
                  {LRData?.Inward_Data?.Received_At_Data && (
                    <div className="vehicleD">{LRData?.Inward_Data?.Received_At_Data?.Warehouse_Name}</div>
                  )}
                  {LRData?.Connection_Memo_Data?.[0]?.To_Connection_Center_Data && (
                    <div className="vehicleD">
                      To CC: {LRData?.Connection_Memo_Data?.[0]?.To_Connection_Center_Data?.Warehouse_Name}
                    </div>
                  )}
                  {/* {cc} */}

                  {/* {Doc} */}
                  {LRData?.Connection_Memo_Data && (
                    <div className="vehicleD">
                      <span>{LRData?.Connection_Memo_Data[0]?.Vendor_Document_No}</span>
                    </div>
                  )}
                  {LRData?.Connection_Memo_Data && (
                    <div className="vehicleD">
                      <span>{LRData?.Connection_Memo_Data[0]?.RR_or_AWB_No}</span>
                    </div>
                  )}
                  {LRData?.Delivery_Memo_Data && (
                    <div className="vehicleD">
                      <span>{LRData?.Delivery_Memo_Data?.Vendor_Doc_No}</span>
                    </div>
                  )}
                  {/* {Doc} */}
                  {/* {Memo No} */}
                  {LRData?.Pickup_Memo_Data?.PRS_NO && (
                    <div className="vehicleD">
                      {LRData?.Pickup_Memo_Data?.PRS_NO || LRData?.Pickup_Memo_Data?.PRS_NO}
                    </div>
                  )}
                  {LRData?.Connection_Memo_Data?.[0]?.Memo_No && (
                    <div className="vehicleD">
                      {LRData?.Connection_Memo_Data?.[0]?.Memo_No || LRData?.Connection_Memo_Data?.[0]?.Memo_No}
                    </div>
                  )}
                  {LRData?.Delivery_Memo_Data?.DRS_No && (
                    <div className="vehicleD">
                      {LRData?.Delivery_Memo_Data?.DRS_No || LRData?.Delivery_Memo_Data?.DRS_No}
                    </div>
                  )}
                  {/* {Memo No} */}
                </div>
              </div>
            </div>
          </StyledTask>
        )}
      </Draggable>
    </>
  );
};

export default LRCard;

const StyledTask = styled.div`
  user-select: none;
  padding: 8px 8px;
  margin: 0 0 8px 0;
  min-height: 50px;
  /* width: 250px; */
  /* overflow-y: visible; */
  font-size: 0.9rem;
  background-color: ${(props) => (props.isDragging ? "lightgreen" : "white")};
  border: 1px solid transparent; // Default border color
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1); // Subtle shadow for non-dragging state
  transition: border 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
  border-radius: 5px;
  rotate: ${(props) => (props.isDragging ? "5deg" : "0deg")};
  &:hover {
    border: 1px solid #9ecd97; // Blue border on hover
    /* transform: scale(1.01); */
    /* background-color: #f0f0f0; */
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2); // More pronounced shadow on hover
  }

  // Ensuring text wraps
  white-space: normal; // Allow text to wrap
  word-wrap: break-word; // Break the word to prevent overflow
  overflow: hidden; // Hide the overflowed content
`;

//  <div className="serviceNameMaindiv">
//               {columnHeader == "Assingn_Pickup" && (
//                 <input
//                   type="checkbox"
//                   name=""
//                   id=""
//                   checked={MultiDragableIds.includes(LRData?._id)}
//                   disabled={disableLRArr?.includes(LRData?._id)}
//                   onChange={(e) => selectMultiIds(LRData?._id, columnHeader)}
//                 />
//               )}
//               {LRData?.Service_Type_Data?.Service_Type_Name && (
//                 <div className="serviceTypeBtn">
//                   {`${LRData?.Service_Type_Data?.Service_Type_Name}`}
//                 </div>
//               )}
//             </div>

//             <div style={{ fontWeight: "bold" }}>{LRData?.Consignor}</div>
//             {LRData?.Consignor_Address && <div>{LRData?.Consignor_Address}</div>}
//             {LRData?.Inward_Data?.Received_At_Data && (
//               <div>CC: {LRData?.Inward_Data?.Received_At_Data?.Warehouse_Name}</div>
//             )}
//             {LRData?.Consignor_Person_Data && (
//               <div>
//                 Contact:{" "}
//                 <span>
//                   {LRData?.Consignor_Person_Data?.Name} - {LRData?.Consignor_Person_Data?.Contact}
//                 </span>
//               </div>
//             )}
//             {LRData?.Notes && (
//               <div>
//                 Notes: <span>{LRData?.Notes}</span>
//               </div>
//             )}
//             {LRData?.Connection_Memo_Data?.[0]?.To_Connection_Center_Data && (
//               <div>
//                 CC: <span>{LRData?.Connection_Memo_Data[0]?.To_Connection_Center_Data?.Warehouse_Name}</span>
//               </div>
//             )}
//             {LRData?.To_City && (
//               <div>
//                 To: <span>{LRData?.To_City}</span>
//               </div>
//             )}
//             {LRData?.Consignee && (
//               <div>
//                 Consignee: <span>{LRData?.Consignee}</span>
//               </div>
//             )}
//             {LRData?.Consignee_Person_Data && (
//               <div>
//                 Contact:{" "}
//                 <span>
//                   {LRData?.Consignee_Person_Data?.Name} - {LRData?.Consignee_Person_Data?.Contact}
//                 </span>
//               </div>
//             )}
//             {LRData?.LR_No && (
//               <div>
//                 LR No:{" "}
//                 <span>{`${LRData?.LR_No}`}</span>
//               </div>
//             )}

//             {LRData?.Total_Number_Of_Boxes && (
//               <div>
//                 Total Item:{" "}
//                 <span>{`(${LRData?.Total_Number_Of_Boxes} pcs - ${LRData?.Total_Weight} kg)`}</span>
//               </div>
//             )}
//             {LRData?.Connection_Memo_Data && (
//               <div>
//                 DOC No: <span>{LRData?.Connection_Memo_Data[0]?.Vendor_Document_No}</span>
//               </div>
//             )}
//             {LRData?.Delivery_Memo_Data && (
//               <div>
//                 DOC No: <span>{LRData?.Delivery_Memo_Data?.Vendor_Doc_No}</span>
//               </div>
//             )}
//             {/* vehicle */}
//             {LRData?.Delivery_Memo_Data?.Vehicle_No_Data && (
//               <div>
//                 Vehicle No: <span>{LRData?.Delivery_Memo_Data?.Vehicle_No_Data?.RC_Number || LRData?.Delivery_Memo_Data?.Vehicle_No_Data?.Vehicle_No}</span>
//               </div>
//             )}
//             {LRData?.Pickup_Memo_Data?.Vehicle_Data && (
//               <div>
//                 Vehicle No: <span>{LRData?.Pickup_Memo_Data?.Vehicle_Data?.RC_Number || LRData?.Pickup_Memo_Data?.Vehicle_Data?.Vehicle_No}</span>
//               </div>
//             )}
//             {LRData?.Connection_Memo_Data?.[0]?.Vehicle_Data && (
//               <div>
//                 Vehicle No: <span>{LRData?.Connection_Memo_Data[0]?.Vehicle_Data?.RC_Number || LRData?.Connection_Memo_Data[0]?.Vehicle_Data?.Vehicle_No}</span>
//               </div>
//             )}
//             {LRData?.pickup_Updation_Data?.Vehicle_No_Data && (
//               <div>
//                 Vehicle No: <span>{LRData?.pickup_Updation_Data?.Vehicle_No_Data?.RC_Number || LRData?.pickup_Updation_Data?.Vehicle_No_Data?.Vehicle_No}</span>
//               </div>
//             )}
//             {LRData?.Connection_Updation_Data?.[0]?.Vehicle_No_Data && (
//               <div>
//                 Vehicle No: <span>{LRData?.Connection_Updation_Data[0]?.Vehicle_No_Data?.RC_Number || LRData?.Connection_Updation_Data[0]?.Vehicle_No_Data?.Vehicle_No}</span>
//               </div>
//             )}
//             {/* driver */}
//             {LRData?.Pickup_Memo_Data?.Driver_Name_Data?.Name && (
//               <div>
//                 Driver:{" "}
//                 <span>{`${LRData?.Pickup_Memo_Data?.Driver_Name_Data?.Name
//                   ? LRData?.Pickup_Memo_Data?.Driver_Name_Data?.Name
//                   : ""
//                   } - ${LRData?.Pickup_Memo_Data?.Driver_Name_Data?.Mobile_Number
//                     ? LRData?.Pickup_Memo_Data?.Driver_Name_Data?.Mobile_Number
//                     : ""
//                   }`}</span>
//               </div>
//             )}
//             {LRData?.pickup_Updation_Data?.Driver_Name_Data?.Name && (
//               <div>
//                 Driver:{" "}
//                 <span>{`${LRData?.pickup_Updation_Data?.Driver_Name_Data?.Name} - ${LRData?.pickup_Updation_Data?.Driver_Name_Data?.Mobile_Number}`}</span>
//               </div>
//             )}
//             {LRData?.Delivery_Memo_Data?.Driver_ID_Data?.Name && (
//               <div>
//                 Driver:{" "}
//                 <span>{`${LRData?.Delivery_Memo_Data?.Driver_ID_Data?.Name} - ${LRData?.Delivery_Memo_Data?.Driver_ID_Data?.Mobile_Number}`}</span>
//               </div>
//             )}
